import gql from 'graphql-tag'

export const UPDATE_SESSION_REFERENCE = gql`
  mutation {
    updateSessionReference
  }
`
